module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LY-d9ddac4dba4d0af65fd74e698aab49af.png";